<template>
  <nx-fullscreen-dialog
    :active="active"
    color="nx-primary--darken-3"
    back
    small-title
    hide-scroll
    :title="backTitle"
    toolbar-height="48"
    @dismiss="handleDismiss">

    <template slot="toolbar-items">
      <v-tooltip left v-if="entity && type">
        <v-fab-transition slot="activator">
          <v-btn
            v-if="entity"
            :to="entityEditorRoute.get(type, entity)"
            target="_blank"
            color="accent"
            flat dark icon>
            <v-icon color="accent">open_in_new</v-icon>
          </v-btn>
        </v-fab-transition>
        <span v-html="$t('message.editor.preview.openNewTab')"></span>
      </v-tooltip>
      <v-btn
        @click.stop="bag = !bag"
        flat dark icon>
        <v-icon :color="bag ? null : 'accent'">inbox</v-icon>
      </v-btn>
    </template>
    <nx-entity-modal-editor
      v-if="active"
      ref="editor"
      :id="id"
      :type="type"
      :entity="entity"
    />
    <v-navigation-drawer
      v-if="features.CONTENT_BAG_FEATURE"
      fixed
      app
      v-model="bag"
      right
      class="nx-ignore-loading mt-5 pb-5"
      width="360">
      <nx-bag v-if="active"></nx-bag>
    </v-navigation-drawer>
    <nx-dialog-confirm
      :text="$t('message.content.editor.unsavedChangesConfirmText')"
      :title="$t('message.content.editor.unsavedChanges')"
      :accept-text="$t('message.content.editor.unsavedChangesAcceptText')"
      :cancel-text="$t('message.content.editor.unsavedChangesCancelText')"
      accept-color="primary"
      cancel-color="primary"
      ref="confirm"
    ></nx-dialog-confirm>
  </nx-fullscreen-dialog>
</template>

<script>
import { entityEditorRoute } from '@/modules/entity/router';
import NxFullscreenDialog from '@/components/dialogs/FullscreenDialog';
import NxDialogConfirm from '@/components/dialogs/Confirm';
import NxBag from '@/modules/bag/Bag';
import NxEntityModalEditor from '@/modules/entity/editor/EntityModalEditor';
import { mapGetters } from 'vuex';

export default {
  name: 'nx-entity-modal-editor-dialog',
  components: {
    NxEntityModalEditor,
    NxBag,
    NxFullscreenDialog,
    NxDialogConfirm,
  },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
    },
    parentTitle: {
      type: String,
    },
    type: {
      type: String,
    },
    entity: {
      type: Object,
    },
  },
  data() {
    return {
      entityEditorRoute,
    };
  },
  computed: {
    ...mapGetters(['features']),
    bag: {
      get() {
        return this.$store.state.app.bag;
      },
      set(value) {
        this.$store.dispatch('TOGGLE_BAG', value);
      },
    },
    backTitle() {
      if (this.parentTitle) {
        return this.$t('message.entity.modal.backTitle', { text: this.parentTitle });
      }
      return this.$t('message.common.back');
    },
  },
  methods: {
    async handleDismiss() {
      if (this.$refs.editor.isDirty()) {
        this.$emit('dismiss');
        this.$refs.editor.reset();
        return;
      }

      // Unsaved changes
      const agree = await this.$refs.confirm.open();
      if (agree) {
        this.$emit('dismiss');
        this.$refs.editor.reset();
      }
    },
  },
};
</script>
